module.exports = __webpack_public_path__ + "img/background.3d12b497.jpg";